import { UseLoading } from "@/common/composition/loading";
import { POPULATION_TYPE } from "@/common/models";
import { SharedState } from "@/common/state";
import { FamiliarityEntityType } from "@/views/customize/in-motion/exposure-control/data/models";
import { Ref, ref } from "@vue/composition-api";
import { Subject } from "./model";
import { get_entity_trust_status } from "@/views/investigation/data/api";
import { take_first_with_value } from "@/fp";

const entity_info_trust: Ref<Array<{
  id: string;
  name: string;
  level: number;
  code: number;
}>> = ref([]);

const [is_loading_entity_trust, set_is_loading_trust] = UseLoading(
  false
).as_arr();

const is_trust_relevant_for_entity = (subject: Subject): boolean =>
  ENTITY_THAT_HAS_TRUST_LEVEL.includes(subject.type);

const load_entity_trust = async (subject: Subject) => {
  if (!is_trust_relevant_for_entity(subject)) {
    return;
  }
  set_is_loading_trust(true);
  const { id, type, email, name } = subject;
  const entity_id: string = take_first_with_value<string>(
    email || "",
    name,
    id,
    "?"
  );
  const res = (await get_entity_trust_status(
    entity_id.toLowerCase(),
    type as FamiliarityEntityType
  )) as {
    [key: string]: number;
  };
  entity_info_trust.value = Object.entries(res)
    .filter(([l0_id]) => l0_id != SharedState.default_label_id.value)
    .map(([l0_id, level]) => {
      const label = SharedState.allInfoTypes.value[l0_id];
      return {
        id: l0_id,
        name: label.labelName,
        code: label.code,
        order: label.l0Order,
        level: level,
      };
    }) // @ts-ignore
    .sort((a: any, b: any) => a.order - b.order);
  set_is_loading_trust(false);
};
const ENTITY_THAT_HAS_TRUST_LEVEL = [
  POPULATION_TYPE.EMPLOYEE,
  POPULATION_TYPE.ORGANIZATION,
  POPULATION_TYPE.PRIVATE_EMAIL,
];

export const trust_state = {
  is_loading_entity_trust,
  entity_info_trust,
  load_entity_trust,
  is_trust_relevant_for_entity,
};
